<template>
    <div data-component="OrderPreviewLines"
         class="order-preview-lines">
        <OrderPreviewLine v-for="line in lines"
                          :key="line.lineNumber"
                          :line="line"
                          :show-price="showLinePrices">
            {{ line.item.name }}
        </OrderPreviewLine>
    </div>
</template>

<script>
import OrderPreviewLine from '@/epos/vue/modals/OrderPreview/OrderPreviewLine';

export default {
    name: 'OrderPreviewLines',

    components: {
        OrderPreviewLine,
    },

    props: {
        lines: {
            type: Object,
            required: true,
        },
        showLinePrices: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../../less/variables.less";

.order-preview-lines {
    border: 1px solid @btn-default-border;
    box-shadow: 0 3px 8px -9px black;
    border-radius: @border-radius-base;
    align-items: center;
}

</style>
